import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=6f4f63d9&scoped=true&"
import script from "./UserDetail.vue?vue&type=script&lang=ts&"
export * from "./UserDetail.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=6f4f63d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f63d9",
  null
  
)

component.options.__file = "UserDetail.vue"
export default component.exports